import { Suspense } from 'react'

import { RouteObject } from 'react-router-dom'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { RestaurantKnowledgeBaseLazy } from './routes/[restaurant]'
import { KnowledgeBaseWrapperLazy } from './ui'

export const knowledgeBaseRoutes: RouteObject[] = [
  {
    path: 'knowledge-base',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <KnowledgeBaseWrapperLazy />
      </Suspense>
    ),
    children: [
      {
        path: ':restaurant',
        element: (
          <Suspense fallback={<ContentLoader />}>
            <RestaurantKnowledgeBaseLazy />
          </Suspense>
        ),
        children: [
          {
            path: ':folderId',
            element: <RestaurantKnowledgeBaseLazy />,
          },
        ],
      },
    ],
  },
]
